import { Stack, Text } from '@fluentui/react'
import { OUTCOME_GROUPS, outcomeGroup, outcomeLabel } from './performanceLabels'

type OutcomeStatusProps = {
  status: string
}

const OutcomeStatus = ({ status }: OutcomeStatusProps) => {
  const group = OUTCOME_GROUPS[outcomeGroup(status)]
  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 6 }}>
      <span
        role="img"
        aria-label={group.label}
        title={group.label}
        style={{ width: 10, height: 10, flexShrink: 0, borderRadius: 2, backgroundColor: group.color }}
      />
      <Text>{outcomeLabel(status)}</Text>
    </Stack>
  )
}

export default OutcomeStatus
